import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class PetDatesUtils {

    constructor(){

    }
  createDateFromDateAndTime(fecha: string, tiempo: string) {
    const [anio, mes, dia] = fecha.split('-');
    const [hora, minutos, segundos] = tiempo.split(':');

    // Crear el objeto Date con la fecha y la hora
    return new Date(
      `${anio}-${mes}-${dia}T${hora}:${minutos}:${segundos}`
    );
  }
}
